import React from 'react';
import { G, Line, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** %OA — AHU mixing box, dampers in OA & RA streams, mixed SA leaving. */
export function DiagramOutsideAirPercentage() {
  // AHU casing
  const ax = 110, ay = 70, aw = 130, ah = 130;

  return (
    <DiagramCanvas>
      {/* AHU casing */}
      <Rect x={ax} y={ay} width={aw} height={ah} fill={DT.fill} stroke={DT.stroke} strokeWidth="2" rx="4" />
      <SvgText x={ax + aw / 2} y={ay + ah / 2 - 6} fill={DT.desc}
        fontSize="9" fontFamily={DT.sans} textAnchor="middle">AHU</SvgText>
      <SvgText x={ax + aw / 2} y={ay + ah / 2 + 6} fill={DT.desc}
        fontSize="9" fontFamily={DT.sans} textAnchor="middle">mixing plenum</SvgText>

      {/* OA duct (top-left horizontal in) — cool tint */}
      <Rect x={20} y={ay + 14} width={ax - 20} height={22} fill="rgba(122,170,187,0.18)" stroke={DT.stroke} strokeWidth="1.5" />
      {/* OA damper (diagonal blades) */}
      {[0, 1, 2].map(i => (
        <Line key={i} x1={ax - 30 + i * 6} y1={ay + 14} x2={ax - 24 + i * 6} y2={ay + 36}
          stroke={DT.varColor} strokeWidth="1.4" />
      ))}
      <Line x1={30} y1={ay + 25} x2={ax - 5} y2={ay + 25} stroke={DT.arrow} strokeWidth="1.5" />
      <Polygon points={`${ax - 3},${ay + 25} ${ax - 9},${ay + 21} ${ax - 9},${ay + 29}`} fill={DT.arrow} />

      {/* RA duct (bottom-left in) — warm tint */}
      <Rect x={20} y={ay + ah - 36} width={ax - 20} height={22} fill="rgba(255,107,26,0.16)" stroke={DT.stroke} strokeWidth="1.5" />
      {[0, 1, 2].map(i => (
        <Line key={i} x1={ax - 30 + i * 6} y1={ay + ah - 14} x2={ax - 24 + i * 6} y2={ay + ah - 36}
          stroke={DT.varColor} strokeWidth="1.4" />
      ))}
      <Line x1={30} y1={ay + ah - 25} x2={ax - 5} y2={ay + ah - 25} stroke={DT.arrow} strokeWidth="1.5" />
      <Polygon points={`${ax - 3},${ay + ah - 25} ${ax - 9},${ay + ah - 29} ${ax - 9},${ay + ah - 21}`} fill={DT.arrow} />

      {/* SA out (right) */}
      <Rect x={ax + aw} y={ay + ah / 2 - 14} width={330 - (ax + aw)} height={28} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={ax + aw + 8} y1={ay + ah / 2} x2={325} y2={ay + ah / 2} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`325,${ay + ah / 2} 319,${ay + ah / 2 - 4} 319,${ay + ah / 2 + 4}`} fill={DT.arrow} />

      {/* Mixing turbulence inside */}
      <Polygon points={`${ax + 25},${ay + 50} ${ax + 50},${ay + 70} ${ax + 25},${ay + 90} ${ax + 50},${ay + 110}`}
        fill="none" stroke={DT.leader} strokeWidth="1" opacity={0.5} />

      {/* Stream temperature labels */}
      <Rect x={26} y={ay + 5} width={42} height={10} fill="rgba(122,170,187,0.6)" rx="2" />
      <SvgText x={47} y={ay + 13} fill="#0D1B2A" fontSize="8" fontFamily={DT.mono} fontWeight="700" textAnchor="middle">T_OA</SvgText>
      <Rect x={26} y={ay + ah - 11} width={42} height={10} fill="rgba(255,107,26,0.7)" rx="2" />
      <SvgText x={47} y={ay + ah - 3} fill="#0D1B2A" fontSize="8" fontFamily={DT.mono} fontWeight="700" textAnchor="middle">T_RA</SvgText>

      {/* Labels */}
      <LeaderLine x1={70} y1={ay + 25} x2={20} y2={210} varName="Q_OA" desc="Outside air (CFM)" anchor="start" />
      <LeaderLine x1={70} y1={ay + ah - 25} x2={120} y2={210} varName="Q_RA" desc="Return air (CFM)" anchor="middle" />
      <LeaderLine x1={285} y1={ay + ah / 2} x2={310} y2={210} varName="Q_SA" desc="Supply (CFM)" anchor="end" />
      <LeaderLine x1={ax + aw / 2} y1={ay} x2={ax + aw / 2} y2={45} varName="%OA" desc="Q_OA / Q_SA" anchor="middle" />

      <FormulaTag formula="%OA = Q_OA / Q_SA · 100   (or by temperature: (T_RA−T_MA)/(T_RA−T_OA))" />
    </DiagramCanvas>
  );
}
